import { Companion_getInstance3g9vumyncsnd3 as Companion_getInstance } from '../type/GraphQLString.mjs';
import {
  notNull3hndh47e9bowl as notNull,
  Builder320ghmibyd2no as Builder,
  Builder3t31vflw4km89 as Builder_0,
  CompiledVariablecaz6ndkw7us2 as CompiledVariable,
} from '../../../../../../../apollo-kotlin-apollo-api/com/apollographql/apollo/api/CompiledGraphQL.mjs';
import { listOf1jh22dvmctj1r as listOf } from '../../../../../../../kotlin-kotlin-stdlib/kotlin/collections/CollectionsKt.mjs';
import { Companion_getInstance3oldva3up9oia as Companion_getInstance_0 } from '../type/DiscordOAuthState.mjs';
import { Companion_getInstanceoymipm3rjnhd as Companion_getInstance_1 } from '../type/Mutation.mjs';
import { listOfvhqybd2zx248 as listOf_0 } from '../../../../../../../kotlin-kotlin-stdlib/kotlin/collections/collectionJs.mjs';
import { initMetadataForObject1cxne3s9w65el as initMetadataForObject } from '../../../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var BeginDiscordOAuthMutationSelectionsClass;
function BeginDiscordOAuthMutationSelections() {
  if (BeginDiscordOAuthMutationSelectionsClass === VOID) {
    class $ {
      constructor() {
        BeginDiscordOAuthMutationSelections_instance = this;
        this.h6h_1 = listOf([(new (Builder())('state', notNull(Companion_getInstance().z6r_1))).e3a(), (new (Builder())('expiresAt', notNull(Companion_getInstance().z6r_1))).e3a()]);
        this.i6h_1 = listOf_0((new (Builder())('beginDiscordOAuth', Companion_getInstance_0().w6s_1)).o46(listOf_0((new (Builder_0())(Companion_getInstance_1().d6h_1)).z46(new (CompiledVariable())('input')).e3a())).p46(this.h6h_1).e3a());
      }
    }
    initMetadataForObject($, 'BeginDiscordOAuthMutationSelections');
    BeginDiscordOAuthMutationSelectionsClass = $;
  }
  return BeginDiscordOAuthMutationSelectionsClass;
}
var BeginDiscordOAuthMutationSelections_instance;
function BeginDiscordOAuthMutationSelections_getInstance() {
  if (BeginDiscordOAuthMutationSelections_instance === VOID)
    new (BeginDiscordOAuthMutationSelections())();
  return BeginDiscordOAuthMutationSelections_instance;
}
//region block: exports
export {
  BeginDiscordOAuthMutationSelections_getInstance as BeginDiscordOAuthMutationSelections_getInstance1ouhs7sr8oxf4,
};
//endregion

//# sourceMappingURL=BeginDiscordOAuthMutationSelections.mjs.map
